// Constants.
// -----------------------------------------------------------------------------
export const ERROR_STATUS_CODES = [404, 500] as const;
export const DEFAULT_ERROR_COMPONENT_HIDE_ERROR = false;
